<template>
  <div id="container" class="appclick">
    <v-container>
      <Header>
        <font-awesome-icon :icon="['fas', 'diagnoses']" />
        <font-awesome-icon :icon="['fas', 'hand-pointer']" />
        <span class="title">Projects</span>
      </Header>
      <v-row>
        <v-col class="col-12">
          <table>
            <tr>
              <th>Id</th>
              <th>Title</th>
              <th>Recording</th>
              <th>Status</th>
            </tr>
            <tbody>
              <tr
                v-for="event in events"
                :key="event.nid"
                :event="event"
                @click="klik($event, event)"
              >
                <td>{{ event.nid }}</td>
                <td>{{ event.title }}</td>
                <td>{{ event.options_recording }}</td>
                <td>{{ event.field_status }}</td>
              </tr>
            </tbody>
          </table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ProjectService from "@/services/ProjectService.js";
import Header from "@/components/Header.vue";
export default {
  components: {
    Header
  },
  data() {
    return {
      events: []
    };
  },
  mounted() {
    ProjectService.getProjects() // Drupal Views
      .then(response => {
        this.events = response.data;
      })
      .catch(error => {
        if (error.response && error.response.status == 404) {
          this.$router.push({
            name: "404Resource",
            params: { resource: "event" }
          });
        } else {
          this.$router.push({ name: "NetworkError" });
        }
      });
  },
  methods: {
    klik: function(ev, i) {
      this.$session.set("PROJID", i.nid);
      this.$session.set("PROJTITLE", i.title);
      this.$router.push({ name: "summary" });
    }
  }
};
</script>
<style scoped>
table {
  border: 2px solid #42b983;
  border-radius: 3px;
  background-color: #fff;
}

th {
  background-color: #42b983;
  color: rgba(255, 255, 255, 0.66);
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

td {
  background-color: #f9f9f9;
}

th,
td {
  min-width: 120px;
  padding: 10px 20px;
}

th.active {
  color: #fff;
}

th.active .arrow {
  opacity: 1;
}
</style>
